var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info-box',{attrs:{"title":_vm.$t('main.parkingEligibiltyInformation.title'),"text":_vm.$t('main.parkingEligibiltyInformation.text', { parkingSiteName: _vm.parkingSiteName }),"bg-color":"blue","icon-name":"info-large"}})
}
var staticRenderFns = []

export { render, staticRenderFns }